import React from 'react';
import {
  Accordion,
  AccordionGroup,
  AccordionHeader,
  AccordionContent,
} from '../../../core/controls/accordion/Accordion';
import { combineClassNames } from '../../../core/css';

const FeatureItems = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <>
      {items.map((item, key) => {
        return (
          <div key={key} className="standard-features__list-item">
            <ul>
              <li
                className="standard-features__short-cfd"
                dangerouslySetInnerHTML={{ __html: item.shortCFD }}
              />
            </ul>
            <div
              className="standard-features__long-cfd"
              dangerouslySetInnerHTML={{ __html: item.longCFD }}
            />
            {item.disclaimer ? (
              <div
                className="standard-features__disclaimer"
                dangerouslySetInnerHTML={{ __html: item.disclaimer }}
              />
            ) : null}
          </div>
        );
      })}
    </>
  );
};

const StandardFeatures = ({
  features,
  analyticsKey,
  className,
  isOpenDefault = false,
}) => {
  if (features) {
    const featuresArr = Object.keys(features);
    const sections = featuresArr.map((key, index) => {
      return (
        <Accordion key={key}>
          <AccordionGroup
            isOpenDefault={isOpenDefault}
            className={`standard-features__accordion-item${
              index === 0 ? ' standard-features__accordion-item--first' : ''
            }${
              index === featuresArr.length - 1
                ? ' standard-features__accordion-item--last'
                : ''
            }`}>
            <AccordionHeader
              expandIcon="expand"
              collapseIcon="collapse"
              alignButtonLeft
              className="standard-features__accordion-header"
              analyticsKey={analyticsKey}>
              {key}
            </AccordionHeader>
            <AccordionContent className="standard-features__accordion-content">
              <FeatureItems items={features[key]} />
            </AccordionContent>
          </AccordionGroup>
        </Accordion>
      );
    });
    return (
      <div
        className={combineClassNames(
          'standard-features__accordion',
          className
        )}>
        {sections}
      </div>
    );
  }
  return null;
};

export default StandardFeatures;
